import { Spinner } from '@fluentui/react-components';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const UnauthorizedPage = lazy(() =>
  import('../pages/UnauthorizedPage').then((m) => ({
    default: m.UnauthorizedPage,
  })),
);

export const Route = createFileRoute('/unauthorized')({
  component: () => (
    <Suspense fallback={<Spinner style={{ position: 'absolute', top: '25%', left: '50%' }} />}>
      <UnauthorizedPage />
    </Suspense>
  ),
});
